/** Matches content folder listing paths (excludes Page Designer `.html` pages and category `/c/` PLPs). */
export function isContentFolderListingPathname(pathname: string): boolean {
    return !pathname.endsWith('.html') && !pathname.includes('/c/');
}
